
    import {
      getAllClassrooms,
      createClassroom,
      createAllClassrooms,
      updateClassroom,
      deleteClassroom
    } from "@/services/classroom";

    const state = {
      classrooms: [],
      processed: false
    };

    const getters = {
      getClassrooms(state) {
        return state.classrooms;
      },
      classroomProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchClassrooms({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllClassrooms(
              params
            )
              .then(response => {
                commit("SET_CLASSROOMS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createClassroom({ commit }, classroom) {
          return new Promise((resolve, reject) => {
            createClassroom(classroom)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllClassrooms({ commit }, classrooms) {
          return new Promise((resolve, reject) => {
            createAllClassrooms(classrooms)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateClassroom({ commit }, classroom) {
          return new Promise((resolve, reject) => {
            updateClassroom(classroom)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteClassroom({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteClassroom(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_CLASSROOMS(state, data) {
        state.classrooms = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    